import {
  ChangeDetectionStrategy,
  Component,
  Input,
  inject,
} from '@angular/core';
import { ModalRef } from '../modal/modal-ref';
import { VideoComponent } from '../video/video.component';

@Component({
  standalone: true,
  template: `
    <fl-video
      [src]="src"
      [timeDisplay]="timeDisplay"
      (videoEnd)="handleVideoEnd()"
      (videoPlay)="handleVideoPlay()"
    ></fl-video>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [VideoComponent],
})
export class VideoModalComponent {
  private modalRef = inject<ModalRef<VideoModalComponent>>(ModalRef);

  @Input() src: string;

  /** Whether or not to show the current time, total time or time left for the current media */
  @Input() timeDisplay = true;

  constructor() {
    this.modalRef.setResult({
      videoPlayed: false,
      videoEnded: false,
    });
  }

  handleVideoEnd(): void {
    const {
      videoPlayed,
    }: {
      videoPlayed: boolean;
    } = this.modalRef.getResult();
    this.modalRef.setResult({
      videoPlayed,
      videoEnded: true,
    });
  }

  handleVideoPlay(): void {
    const {
      videoEnded,
    }: {
      videoEnded: boolean;
    } = this.modalRef.getResult();
    this.modalRef.setResult({
      videoPlayed: true,
      videoEnded,
    });
  }
}
